<template>
  <div class="edit-delete">
    <a class="tooltip-btn btn-wrap" :class="{'display-text': displayButtonText}" :data-text="$t('EDIT')"
       @click="editEntry">
      <img src="@/assets/images/edit-dark-gray.svg" alt="edit icon" class="icon edit-icon">
      <span v-if="displayButtonText">{{ $t('EDIT') }}</span>
    </a>
    <a v-if="entryStatus === entryApprovalStatuses.PUBLISHED" class="tooltip-btn btn-wrap display-text delete"
       :data-text="$t('DELETE')" @click="openPopup('DELETED')">
      <img src="@/assets/images/trash_icon.svg" class="trash-icon"/>
      <span>{{ $t('DELETE') }}</span>
    </a>
    <template v-else>
      <a v-if="isContributor" class="btn-wrap content-approval-btn"
         :data-text="$t('SEND_TO_APPROVAL')"
         @click="openPopup(entryApprovalStatuses.PENDING)"
         :class="{disabled: getIsDisableSendToApproval(collectionEntry), 'display-text': displayButtonText,
         'tooltip-btn': !getIsDisableSendToApproval(collectionEntry)}">
        <img src="@/assets/images/send-green-small.svg" alt="" class="icon send-fly-icon">
        <span v-if="displayButtonText">{{ $t('SEND_TO_APPROVAL') }}</span>
      </a>
      <template v-else>
        <a class="tooltip-btn btn-wrap content-approval-btn" :data-text="$t('PUBLISH')"
           @click="openPopup(entryApprovalStatuses.PUBLISHED)"
           :class="{'display-text': displayButtonText}">
          <img src="@/assets/images/vi-green.svg" alt="" class="icon send-icon">
          <span v-if="displayButtonText">{{ $t('PUBLISH') }}</span>
        </a>
        <a class="btn-wrap content-approval-btn"
           v-if="entryStatus !== entryApprovalStatuses.REJECTED || displayButtonText"
           :data-text="$t('REJECTION')"
           :class="{'display-text': displayButtonText,
           disabled: entryStatus === entryApprovalStatuses.REJECTED,
           'tooltip-btn': entryStatus !== entryApprovalStatuses.REJECTED}"
           @click="openPopup(entryApprovalStatuses.REJECTED)">
          <img src="@/assets/images/x-red.svg" alt="" class="icon">
          <span v-if="displayButtonText">{{ $t('REJECTION') }}</span>
        </a>
      </template>
    </template>
    <component :is="getPopupComponentName"
         v-if="openPopupType"
         :collectionTitle="collectionTitle"
         @close-popup="closePopup" @approve-popup-function="approvePopupFunction"
    ></component>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { getUploadType } from '@/utilityFunctions'
import SentForApprovalPopup from '@/components/sent-to-approval-popup'
import { entryApprovalStatuses, permissionTypes } from '@/constants'
import PublishPopup from '@/components/publish-popup'
import RejectedPopup from '@/components/rejected-popup'
import DeleteContent from '@/components/delete-content'

export default {
  name: 'entry-management-toolbar',

  data () {
    return {
      openPopupType: null,
      entryApprovalStatuses
    }
  },

  components: { DeleteContent, SentForApprovalPopup, PublishPopup, RejectedPopup },

  props: {
    collectionEntry: {
      type: Object,
      required: true
    },
    displayButtonText: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    editEntry () {
      this.$store.dispatch('findAndSetEntryById', this.collectionEntry.data.id)
      this.$router.push({
        name: 'edit-collection',
        params: {
          id: this.collectionEntry.data.id,
          type: this.getUploadType
        },
        query: {
          searchText: this.$route.query.searchText,
          filters: this.$route.query.filters
        }
      })
    },
    openPopup (statusPopup) {
      if (statusPopup === entryApprovalStatuses.PENDING) {
        if (this.getIsDisableSendToApproval(this.collectionEntry)) return
        this.$store.dispatch('updateCollectionEntryStatus', { id: this.collectionEntry.data.id, action: 'submitted' })
          .then(() => {
            this.openPopupType = statusPopup
          })
      } else {
        this.openPopupType = statusPopup
      }
    },
    closePopup () {
      this.openPopupType = null
    },
    approvePopupFunction (data) {
      if (data.action === 'delete') {
        this.$store.dispatch('deleteSelectedEntry').then(() => {
          this.$router.push('/' + this.librarySlug + '/base')
        })
      } else {
        this.$store.dispatch('updateCollectionEntryStatus', { id: this.collectionEntry.data.id, action: data.action, comment: data.comment })
        this.closePopup()
      }
    }
  },

  computed: {
    ...mapState({
      userRoles: state => state.base.userRoles,
      librarySlug: state => state.base.library.slug
    }),
    ...mapGetters(['getIsDisableSendToApproval']),
    getUploadType () {
      return getUploadType(this.collectionEntry)
    },
    entryStatus () {
      return this.collectionEntry.data.published_status
    },
    isContributor () {
      return this.userRoles?.includes(permissionTypes.CONTRIBUTOR)
    },
    collectionTitle () {
      return this.collectionEntry.data.title
    },
    getPopupComponentName () {
      switch (this.openPopupType) {
        case entryApprovalStatuses.PENDING:
          return 'sent-for-approval-popup'
        case entryApprovalStatuses.PUBLISHED:
          return 'publish-popup'
        case entryApprovalStatuses.REJECTED:
          return 'rejected-popup'
        case 'DELETED':
          return 'delete-content'
        default:
          return null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  width: 23px; height: 23px;
}

.btn-wrap {
  display: flex; align-items: flex-end; gap: 3px;
  &.delete{align-items: center;}
  * {font-size: 16px;}
}
</style>
